export default {
  logo: "قورئانی پیرۆز",
  info: "فایلە دەنگییەکان وەرگیراون لە وێب سایتی:"
}